import { SearchQuery } from "../api"
import { parseNumber } from "@nosto/search-js/utils"

export default function ensureSearchQueryNumbers({ products, ...rest }: SearchQuery): SearchQuery {
    return {
        ...rest,
        products: {
            ...products,
            ...(products?.from ? { from: parseNumber(products.from) } : {}),
            ...(products?.size ? { size: parseNumber(products.size) } : {})
        }
    }
}
